import Page from "common/entities/Page";
import Contact from "./views/Contact";
import Education from "./views/Education";
import Experience from "./views/Experience";
import Home from "./views/Home";
import Projects from "./views/Projects";
import Skills from "./views/Skills";

const Views: Page[] = [Home, Experience, Education, Skills, Projects, Contact];

export default Views;
